import { useEffect, useState } from "react";

import { productsCollRef } from "../../../utils/referencies";

const useCanUpdateBrandCategory = (productId: string) => {
  const [canUpdateCategory, setCanUpdateCategory] = useState(false);
  const [loading, setLoading] = useState(false);

  /**
   * check if at least one product contains this category or not
   * */
  useEffect(() => {
    (async function () {
      try {
        setLoading(true);
        const snapshot = await productsCollRef.where("categoryId", "==", productId).limit(1).get();
        console.log(snapshot.empty);
        if (snapshot.empty) setCanUpdateCategory(true);
        else setCanUpdateCategory(false);
        setLoading(false);
      } catch (ex: any) {
        console.log(ex.message);
        setCanUpdateCategory(false);
        setLoading(false);
      }
    })();
  }, [productId]);

  return { canUpdateCategory, loading };
};

export default useCanUpdateBrandCategory;
